import type { Domain } from '@/config/domain/type';
import { getDomainFromHost } from '@/core/util/domain-utils';


export default function useDomain(): Domain {
    return getDomainFromHost(window.location.host);
}
